import { render } from "./ActivityContext.vue?vue&type=template&id=3b858c16&scoped=true"
import script from "./ActivityContext.vue?vue&type=script&lang=js"
export * from "./ActivityContext.vue?vue&type=script&lang=js"

import "./ActivityContext.vue?vue&type=style&index=0&id=3b858c16&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b858c16"]])

export default __exports__